import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { OctagonMinus } from "lucide-react";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import GameHostingPage from "./pages/GameHostingPage";
import DedicatedPage from "./pages/DedicatedPage";
import WebHostingPage from "./pages/WebHostingPage";

import SupportPage from "./pages/SupportPage";
import LegalPage from "./pages/LegalPage";


// Not Found Page (404)
import NotFound from "./pages/error/NotFound";


const AppContent = () => (
  <Layout>
    <Routes>
      <Route index element={<HomePage />} />
      <Route path="/game-hosting" element={<GameHostingPage />} />
      <Route path="/dedicated" element={<DedicatedPage />} />
      <Route path="/web-hosting" element={<WebHostingPage />} />

      <Route path="/support" element={<SupportPage />} />
      <Route path="/legal" element={<LegalPage />} />
      <Route path="*" element={<NotFound />} />

    </Routes>
  </Layout>
);

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
